import { render, staticRenderFns } from "./WorkOrderRealTime.vue?vue&type=template&id=25547056&scoped=true"
import script from "./WorkOrderRealTime.vue?vue&type=script&lang=js"
export * from "./WorkOrderRealTime.vue?vue&type=script&lang=js"
import style0 from "./WorkOrderRealTime.vue?vue&type=style&index=0&id=25547056&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25547056",
  null
  
)

export default component.exports